const TASA_CAMBIO_EUR = 0.94; // 1 USD -> EUR (Aprox)
const PRECIO_ENTRADA_USD = 0.5;
const PRECIO_SALIDA_USD = 3.0;

/**
 * Calcula el desglose de costes para una consulta a Gemini 2.5 Flash Preview
 * Los thoughts se facturan como tokens de entrada (input)
 */
const calcularCosteGemini = (tokens) => {
  const totalEntrada = tokens.promptTokens + (tokens.thoughtsTokens || 0);
  const totalSalida = tokens.responseTokens;

  const costeEntradaUSD = (totalEntrada / 1_000_000) * PRECIO_ENTRADA_USD;
  const costeSalidaUSD = (totalSalida / 1_000_000) * PRECIO_SALIDA_USD;
  const totalUSD = costeEntradaUSD + costeSalidaUSD;

  return {
    detallesTokens: {
      entradaTotal: totalEntrada,
      salida: totalSalida
    },
    costesEUR: {
      entrada: (costeEntradaUSD * TASA_CAMBIO_EUR).toFixed(6) + " €",
      salida: (costeSalidaUSD * TASA_CAMBIO_EUR).toFixed(6) + " €",
      total: (totalUSD * TASA_CAMBIO_EUR).toFixed(6) + " €"
    },
    totalUSD: totalUSD.toFixed(6) + " $"
  };
};

export default calcularCosteGemini;
